import React from 'react';
import { FiRefreshCw } from 'react-icons/fi';
import '../styles/EnvironmentStatus.css';

const EnvironmentStatus = ({ data, loading, onRefresh }) => {
  // Ensure we always have 6 rows (3 applications × 2 environments)
  const ensureCompleteData = (data) => {
    // If no data or invalid data, return empty placeholder
    if (!Array.isArray(data) || data.length === 0) {
      return generateEmptyStatusData();
    }

    // Create a map of expected environments
    const appEnvMap = {
      "Premium Development": false,
      "Premium QA": false,
      "Tentacle Development": false,
      "Tentacle QA": false,
      "Adoption Development": false,
      "Adoption QA": false
    };

    // Mark which environments exist in the data
    data.forEach(item => {
      if (item.environment in appEnvMap) {
        appEnvMap[item.environment] = true;
      }
    });

    // Create a complete dataset by adding missing environments
    const completeData = [...data];

    for (const [env, exists] of Object.entries(appEnvMap)) {
      if (!exists) {
        completeData.push({
          environment: env,
          status: "Stopped",
          "started_by": "",
          stop_time: "—"
        });
      }
    }

    // Sort by environment name for consistent display
    return completeData.sort((a, b) => a.environment.localeCompare(b.environment));
  };

  // Generate empty status data with all possible environments
  const generateEmptyStatusData = () => {
    return [
      // {
      //   environment: "Premium Development",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // },
      // {
      //   environment: "Premium QA",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // },
      // {
      //   environment: "Tentacle Development",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // },
      // {
      //   environment: "Tentacle QA",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // },
      // {
      //   environment: "Adoption Development",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // },
      // {
      //   environment: "Adoption QA",
      //   status: "Stopped",
      //   "started by": "",
      //   stop_time: "—"
      // }
    ];
  };

  // Use the complete dataset for display
  const displayData = ensureCompleteData(data);

  return (
    <div className="environment-status">
      <div className="status-header">
        <h2>Environment Status</h2>
        <button
          className="btn-refresh"
          onClick={onRefresh}
          disabled={loading}
          title="Refresh environment status"
        >
          <FiRefreshCw className={loading ? 'spinning' : ''} />
        </button>
      </div>

      <div className="status-table">
        <div className="table-header">
          <div className="th">Environment</div>
          <div className="th">Status</div>
          <div className="th">Started By</div>
          <div className="th">Stop Time</div>
        </div>

        {loading ? (
          <div className="loading">Loading environment status...</div>
        ) : (
          displayData.map((item, index) => (
            <div key={index} className={`table-row ${item.status.toLowerCase() === 'running' ? 'highlighted-row' : ''}`}>
              <div className="td">{item.environment}</div>
              <div className="td">
                <span className={`status-badge ${item.status.toLowerCase()}`}>
                  {item.status}
                </span>
              </div>
              <div className="td">{item['started_by'] || '—'}</div>
              <div className="td">{item.stop_time || '—'}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default EnvironmentStatus;